import { PipeTransform } from '@angular/core';
var CamelToKebabCasePipe = /** @class */ (function () {
    function CamelToKebabCasePipe() {
    }
    CamelToKebabCasePipe.prototype.transform = function (value) {
        return value.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    };
    return CamelToKebabCasePipe;
}());
export { CamelToKebabCasePipe };
